module.exports = __webpack_public_path__ + "img/cb-f-r-rr1.fb53a693.gif";